import React, { Suspense } from 'react';
import Loader from '../../../components/commons/helpers/loader/loader.component';
import './release-notes.styles.scss';

function NewReleaseNotesLandingPage({ page: { MainContent, breadCrumbList } }) {
  const HeroComponent = React.lazy(() =>
    import('./new-release-notes-hero-component')
  );
  const ContentComponent = React.lazy(() =>
    import('./new-release-notes-content-component')
  );

  return (
    <div className="release-notes-page">
      <Suspense fallback={<Loader />}>
        <HeroComponent
          MainContent={MainContent}
          breadCrumbList={breadCrumbList}
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <ContentComponent MainContent={MainContent} />
      </Suspense>
    </div>
  );
}

export default NewReleaseNotesLandingPage;
